import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "../styles/ImageCarousel.css";

// const settings = {
//   dots: false,
//   infinite: true,
//   speed: 800,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 4000,
//   arrows: false, // Hide arrows for cleaner look
//   adaptiveHeight: false, // Prevents shrinking
// };

const imageItems = [
  { src: "/images/front1.1.jpg", alt: "Resume Analysis" },
  { src: "/images/front2.2.jpg", alt: "FutureTech Training", readMore: true },
  { src: "/images/front6.6.jpg", alt: "Oracle Applications" },
  // { src: "/images/front4.4.jpg", alt: "AI & ML", readMore: true },
  { src: "/images/front3.3.jpg", alt: "Cloud Computing" },
  // { src: "/images/front5.5.jpg", alt: "AI Intro",readmore: true},
];

const ImageCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {imageItems.map((image, index) => (
          <div key={index} className="carousel-slide">
            <img src={image.src} alt={image.alt} className="carousel-image" />
            {/* {image.readMore && (
              <a href="#" className="read-more-btn">Read More</a>
            )} */}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageCarousel;
